import React from "react";
import {Table, Tag} from "antd";
import {useTranslation} from "react-i18next";
import {compareString, getLocaleLang} from "../../../../../utils/helpers";

export const PermissionPolicyList = ({
    permissionPolicies = [],
    loading = false,
    csrSearchText = "",
    showActionColumn = true,
    pageSize = 15,
    tableSize = "small",
    actionButton = () => {}
}) => {
    const {t, i18n} = useTranslation(["userAuthorization"]);
    const csrSearchFilter = (data, searchText) =>
        data && Array.isArray(data)
            ? data.filter(
                  permissionPolicy =>
                      compareString(permissionPolicy.name[getLocaleLang(i18n)], searchText) ||
                      compareString(permissionPolicy.key, searchText) ||
                      permissionPolicy?.tags?.some(tag => compareString(tag, searchText))
              )
            : [];

    return (
        <Table
            rowKey="_id"
            dataSource={csrSearchFilter(permissionPolicies, csrSearchText)}
            pagination={{pageSize, hideOnSinglePage: true}}
            data-testid="userPermissionPoliciesListTable"
            size={tableSize}
            loading={loading}
            style={{overflowX: "auto"}}
        >
            <Table.Column
                dataIndex="name"
                title={t("components.permissionPolicyList.fields.name", {
                    ns: "userAuthorization"
                })}
                render={name => <span data-testid="name">{name[getLocaleLang(i18n)]}</span>}
                sorter={(a, b) =>
                    a?.name[getLocaleLang(i18n)].localeCompare(b?.name[getLocaleLang(i18n)])
                }
            />
            <Table.Column
                dataIndex="key"
                title={t("components.permissionPolicyList.fields.key", {
                    ns: "userAuthorization"
                })}
                render={key => <span data-testid="key">{key}</span>}
                sorter={(a, b) => a?.key.localeCompare(b.key)}
            />
            <Table.Column
                dataIndex="description"
                title={t("components.permissionPolicyList.fields.description", {
                    ns: "userAuthorization"
                })}
                render={description => (
                    <span data-testid="description">{description[getLocaleLang(i18n)]}</span>
                )}
            />
            <Table.Column
                dataIndex="tags"
                title={t("components.permissionPolicyList.fields.tags", {
                    ns: "userAuthorization"
                })}
                render={tags => (
                    <span data-testid="tags">
                        {tags?.map((tag, i) => (
                            <Tag key={i}>{tag}</Tag>
                        ))}
                    </span>
                )}
            />
            {showActionColumn && <Table.Column dataIndex="tags" title={""} render={actionButton} />}
        </Table>
    );
};
